import { Currency } from '../../court-pricing/dto/court-pricing-rule.dto';

export enum OrderType {
  COURT_BOOKING = 'COURT_BOOKING',
  GAME_JOINING = 'GAME_JOINING',
  STANDALONE = 'STANDALONE',
}

export enum OrderStatus {
  PENDING = 'PENDING',
  PAID = 'PAID',
  CANCELLED = 'CANCELLED',
}

export type OrderItemDto = {
  id: string;
  productId: string;
  productName: string;
  quantity: number;
  unitPrice: number;
  currency: Currency;
  totalPrice: number;
  createdAt: Date;
};

export type OrderDto = {
  id: string;
  userId: string;
  userFirstName?: string;
  userLastName?: string;
  userEmail?: string;
  orderType: OrderType;
  totalAmount: number;
  currency: Currency;
  status: OrderStatus;
  gameBookingIntentId?: string;
  gameJoiningIntentId?: string;
  gameId?: string;
  items: OrderItemDto[];
  createdAt: Date;
  updatedAt: Date;
};

export type CreateOrderDto = {
  orderType: OrderType;
  items: CreateOrderItemDto[];
  gameBookingIntentId?: string;
  gameJoiningIntentId?: string;
  gameId?: string;
};

export type CreateOrderItemDto = {
  productId: string;
  quantity: number;
};
